import InfoCircle from '../../src/legacy/InfoCircle.tsx';
export default InfoCircle;
